(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDialogController', MarketplaceDialogController);

    MarketplaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Marketplace'];

    function MarketplaceDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.marketplace.id !== null) {
                Marketplace.update(vm.marketplace, onSaveSuccess, onSaveError);
            } else {
                Marketplace.save(vm.marketplace, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:MarketplaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();
